module.exports = __webpack_public_path__ + "img/slider-3.a2140d9e.jpg";